import React__default from 'react';
import { Typography, ButtonBase } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import StyledKModalHeader, { classes } from './index.styled.js';

var KModalHeader = function (_a) {
    var onClose = _a.onClose, _b = _a.fullscreen, fullscreen = _b === void 0 ? false : _b, _c = _a.onFullscreen, onFullscreen = _c === void 0 ? function () { } : _c, className = _a.className, title = _a.title, children = _a.children, _d = _a.testId, testId = _d === void 0 ? "KModalHeader" : _d, sx = _a.sx;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(StyledKModalHeader, { "data-testid": testId, className: clsx("KModalHeader", className), sx: sx },
        React__default.createElement(Typography, { component: "h1", variant: "subtitle1", className: clsx(classes.title, "KModalHeader-title") }, title || children),
        fullscreen && (React__default.createElement(ButtonBase, { focusRipple: true, className: clsx("KModalHeader-fullscreen", classes.fullscreen), "data-testid": "KModalHeader-fullscreen", onClick: onFullscreen },
            React__default.createElement(Typography, null, t("components.kModal.header.fullscreen.label")))),
        React__default.createElement(ButtonBase, { focusRipple: true, className: clsx(classes.close, "KModalHeader-close"), "data-testid": "KModalHeader-close", onClick: onClose },
            React__default.createElement(Typography, null, t("components.kModal.header.close.label")))));
};

export { KModalHeader as default };
//# sourceMappingURL=index.js.map
